import React from "react";
import "./Card.css";

const Card = ({ 
  icon, 
  title, 
  subtitle, 
  data, 
  comparison, 
  onClick,
  className = "",
  variant = "default", // default, primary, success, warning, danger
  children
}) => {
  return (
    <div 
      className={`card ${variant} ${className} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      {/* Header Section */}
      {(icon || title || subtitle) && (
        <div className="card-header">
          {icon && <div className="card-icon">{icon}</div>}
          <div className="card-title-section">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
        </div>
      )}

      {/* Data Section */}
      {data && (
        <div className="card-data">
          {typeof data === 'object' ? (
            <div className="card-data-value">{data.value}</div>
          ) : (
            <div className="card-data-value">{data}</div>
          )}
          {typeof data === 'object' && data.label && (
            <div className="card-data-label">{data.label}</div>
          )}
        </div>
      )}

      {/* Comparison/Statistic Section */}
      {comparison && (
        <div className="card-comparison">
          {typeof comparison === 'object' ? (
            <>
              <span className={`comparison-value ${comparison.type || ''}`}>
                {comparison.value}
              </span>
              {comparison.label && (
                <span className="comparison-label">{comparison.label}</span>
              )}
            </>
          ) : (
            <span className="comparison-text">{comparison}</span>
          )}
        </div>
      )}

      {/* Children - for custom content */}
      {children}
    </div>
  );
};

export default Card;


